export const READING_MODE_KEY = "wr:rm";

export const isReadingModeEnabled = () => {
  try {
    return localStorage.getItem(READING_MODE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setReadingModeValue = (enabled) => {
  try {
    if (enabled) {
      localStorage.setItem(READING_MODE_KEY, "1");
    } else {
      localStorage.removeItem(READING_MODE_KEY);
    }
  } catch {
    // localStorage unavailable (e.g. private browsing) - fail silently
  }
};